interface Props {
    titulo: any[];
    mbodyResult: any[];
    body: any[];
    keyId: string;
    onChange?: Function;
}

export const HeadMultiSelectTable = ({ titulo, body, mbodyResult, keyId, onChange }: Props) => {

    const allCurrentPageSelected =
        body.length > 0 &&
        body.every(bean =>
            mbodyResult.some(
                item =>
                    item.DataBeanProperties[keyId] ===
                    bean.DataBeanProperties[keyId]
            )
        );

    const toggleSelectAll = () => {

        const pageIds = body.map(
            b => b.DataBeanProperties[keyId]
        );

        if (allCurrentPageSelected) {

            const filtered = mbodyResult.filter(
                item =>
                    !pageIds.includes(
                        item.DataBeanProperties[keyId]
                    )
            );

            onChange(filtered);

        } else {

            const existingIds = new Set(
                mbodyResult.map(
                    i => i.DataBeanProperties[keyId]
                )
            );

            const newItems = body.filter(
                b =>
                    !existingIds.has(
                        b.DataBeanProperties[keyId]
                    )
            );

            onChange([
                ...mbodyResult,
                ...newItems
            ]);
        }
    };

    return (
        <thead>
            <tr>
                <th
                    onClick={toggleSelectAll}
                    style={{ cursor: "pointer", userSelect: "none" }}
                >
                    <span>Seleccionar Todos </span>

                    <input
                        type="checkbox"
                        checked={allCurrentPageSelected}
                        onClick={(e) => e.stopPropagation()}
                        onChange={toggleSelectAll}
                    />
                </th>

                {titulo.map((item: any) =>
                    item.visible && (
                        <th key={item.id || item.title}>
                            {item.title}
                        </th>
                    )
                )}
            </tr>
        </thead>
    );
};